// extracted by mini-css-extract-plugin
export default {"field":"app-components-uiKit-SelectField-SelectField-module__KdzfduszjDONL75nDYYB"};